<app-modal
  [isOpen]="show"
  title="Consulta — Ordem de Serviço"
  [size]="'lg'"
  [closable]="true"
  [hideScrollbar]="true"
  (close)="close()">

  <div *ngIf="loading" class="modal-loading">
    <i class="fas fa-spinner fa-spin"></i>
    <span>Carregando...</span>
  </div>

  <div *ngIf="error && !loading" class="alert alert-danger">
    <i class="fas fa-exclamation-triangle me-2"></i>
    {{ error }}
  </div>

  <ng-container *ngIf="serviceOrder && !loading">
    <div class="os-summary">
      <div class="summary-header">
        <h4 class="os-number">{{ serviceOrder.numeroOS || '-' }}</h4>
        <span class="badge status-badge">{{ serviceOrder.status || '-' }}</span>
      </div>

      <div class="summary-grid">
        <div class="summary-field">
          <span class="label">Tipo OS</span>
          <span class="value">{{ getTipoOSNome() }}</span>
        </div>
        <div class="summary-field">
          <span class="label">Data abertura</span>
          <span class="value">{{ formatarData(serviceOrder.dataAbertura) }}</span>
        </div>
        <div class="summary-field">
          <span class="label">Motivo abertura</span>
          <span class="value">{{ serviceOrder.motivoAbertura || '-' }}</span>
        </div>
        <div class="summary-field">
          <span class="label">Veículo / Placa</span>
          <span class="value">{{ serviceOrder.veiculoPlaca || '-' }}</span>
        </div>
        <div class="summary-field" *ngIf="serviceOrder.clienteNome">
          <span class="label">Cliente</span>
          <span class="value">{{ serviceOrder.clienteNome }}</span>
        </div>
        <div class="summary-field">
          <span class="label">Setor atual</span>
          <span class="value">{{ getSetorAtual() }}</span>
        </div>
        <div class="summary-field summary-field--wide" *ngIf="serviceOrder.descricao">
          <span class="label">Descrição</span>
          <span class="value">{{ serviceOrder.descricao }}</span>
        </div>
      </div>
    </div>

    <div class="servicos-section">
      <button
        type="button"
        class="section-toggle"
        (click)="toggleServicosSection()"
        [attr.aria-expanded]="servicosExpanded">
        <h5 class="section-title">
          <i class="fas fa-tools me-2"></i>
          Serviços (sessões de trabalho)
          <span class="section-count" *ngIf="workSections.length > 0">({{ workSections.length }})</span>
        </h5>
        <i class="fas section-chevron" [class.fa-chevron-down]="!servicosExpanded" [class.fa-chevron-up]="servicosExpanded"></i>
      </button>

      <div class="section-body" *ngIf="servicosExpanded">
        <div class="work-sections-list" *ngIf="workSections.length > 0">
          <div class="work-section-card" *ngFor="let section of workSections">
            <div class="work-section-header">
              <strong>{{ section.description || 'Sessão sem descrição' }}</strong>
              <span class="badge work-section-status" *ngIf="section.status">{{ section.status }}</span>
            </div>

            <div class="work-section-block" *ngIf="getSectionServices(section).length > 0">
              <span class="work-section-block-title">Serviços</span>
              <ul class="work-section-lines">
                <li *ngFor="let svc of getSectionServices(section)">
                  <span class="line-desc">{{ svc.description || '-' }}</span>
                  <span class="line-meta">
                    Qtd: {{ svc.quantity ?? 0 }} · {{ formatarValor(svc.totalValue) }}
                    <span *ngIf="svc.status" class="line-status"> · {{ svc.status }}</span>
                  </span>
                </li>
              </ul>
            </div>

            <div class="work-section-block" *ngIf="getSectionItems(section).length > 0">
              <span class="work-section-block-title">Peças / Itens</span>
              <ul class="work-section-lines">
                <li *ngFor="let item of getSectionItems(section)">
                  <span class="line-desc">{{ item.description || '-' }}</span>
                  <span class="line-meta">
                    Qtd: {{ item.quantity ?? 0 }} · {{ formatarValor(item.totalValue) }}
                  </span>
                </li>
              </ul>
            </div>

            <p class="work-section-empty" *ngIf="getSectionServices(section).length === 0 && getSectionItems(section).length === 0">
              Nenhum serviço ou item nesta sessão.
            </p>
          </div>
        </div>

        <div class="historico-empty" *ngIf="workSections.length === 0">
          <i class="fas fa-clipboard-list"></i>
          <p>Nenhuma sessão de trabalho registrada para esta OS.</p>
        </div>
      </div>
    </div>

    <div class="historico-section">
      <button
        type="button"
        class="section-toggle"
        (click)="toggleHistoricoSection()"
        [attr.aria-expanded]="historicoExpanded">
        <h5 class="section-title">
          <i class="fas fa-history me-2"></i>
          Histórico de movimentações
          <span class="section-count" *ngIf="historico.length > 0">({{ historico.length }})</span>
        </h5>
        <i class="fas section-chevron" [class.fa-chevron-down]="!historicoExpanded" [class.fa-chevron-up]="historicoExpanded"></i>
      </button>

      <div class="section-body" *ngIf="historicoExpanded">
        <div class="historico-timeline" *ngIf="historico.length > 0">
          <div class="timeline-item" *ngFor="let evento of historico">
            <div class="timeline-marker" [style.background-color]="getCorEvento(evento.tipo)">
              <i [class]="getIconeEvento(evento.tipo)"></i>
            </div>
            <div class="timeline-content">
              <div class="timeline-header">
                <strong>{{ evento.acao }}</strong>
                <span class="timeline-date">
                  <i class="fas fa-clock"></i> {{ formatarDataHora(evento.dataHora) }}
                </span>
              </div>
              <p class="timeline-details" *ngIf="evento.detalhes">{{ evento.detalhes }}</p>
              <div class="timeline-badges">
                <span class="badge badge-setor" *ngIf="evento.setorAtual">{{ evento.setorAtual }}</span>
                <span class="badge badge-old" *ngIf="evento.statusAnterior">{{ evento.statusAnterior }}</span>
                <span class="badge badge-new" *ngIf="evento.statusNovo">{{ evento.statusNovo }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="historico-empty" *ngIf="historico.length === 0">
          <i class="fas fa-inbox"></i>
          <p>Nenhum registro de histórico encontrado para esta OS.</p>
        </div>
      </div>
    </div>
  </ng-container>
</app-modal>
